import fs from 'node:fs'
import path from 'node:path'
import { resolveCliAssetPath } from '@cli-utils/paths.js'

export function readTemplate(relativePath: string): string {
  return fs.readFileSync(
    path.join(resolveCliAssetPath('adapters', 'next', 'templates', 'init'), relativePath),
    'utf-8'
  )
}
